package com.downdogapp.client

actual fun createServerImage(url: String) : ServerImage = JsServerImage(url)